import React from "react";
import { BsPatchCheckFill } from "react-icons/bs";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import QRCodeGenerate from "../QRCodeGenerate";
import { Container } from "react-bootstrap";
import QRCodeSecurity from "../QRCodeSecurity/index"
import "./index.css";

export default function PresentQRCode({ eventPageData, hashKey, guestData }) {

    const searchParams = new URLSearchParams(window.location.search);
    const tokenId = searchParams.get("tokenid");
    const contractAddress = searchParams.get("contractaddress");

    return (
        <Container>
            {/* <div className="nft-vip-button">
                {guestData && guestData.section && guestData.section === "VIP" && (
                    <p
                        className="VIP-guest VIP-guest-main"
                    >
                        VIP Pass
                    </p>
                )}
                {guestData && guestData.section && (
                    <div className="nft-angel-twin-btn">
                        <button
                            className="nft-btn-warning"
                            onClick={() => window.open("https://www.angelai.com/points", "_blank")}
                        >
                            Create Your Angel Twin Now
                        </button>
                    </div>
                )}
            </div> */}
            {guestData.qr_code_checked_in > 0 && (
                <Row>
                    <Col className="mb-3">
                        {guestData.qr_code_scan_count === 1 && (
                            <p className="welcomeToEvent">
                                WELCOME TO THE EVENT{" "}
                                <BsPatchCheckFill className="welcomeToEventCheckMark" />
                            </p>
                        )}
                        {guestData.qr_code_scan_count > 1 && (
                            <p className="nftAlreadyRegistered">
                                THIS NFT HAS ALREADY BEEN REGISTERED{" "}
                                <BsPatchCheckFill className="nftAlreadyRegisteredCheckMark" />
                            </p>
                        )}
                    </Col>
                </Row>
            )}
               <Row className="QR-codes-row justify-content-center">
                <Col xs={12} sm={12} md={12} lg={5} className="mb-3">
             < QRCodeSecurity/>
                </Col>
            {tokenId && contractAddress ? (
                                ""
                            ) : (
         
                <Col xs={12} sm={12} md={12} lg={5} className="mb-3 presentQRCodeBox">
                    <div className="presentQRCodeContainer">
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                {/* <p className="digitalArtText">
                                    This Digital Art entitles you to enter the US Strategy for Ai & Crypto event.
                                </p> */}
                                <p className="presentQRCodeText text-center">
                                Present this QR code at Registration Desk.
                                </p>
                            </Col>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <QRCodeGenerate
                                        eventUrl={process.env.REACT_APP_CDN_PAGE_URL}
                                        hashKey={hashKey}
                                    />
                                </Col>
                        </Row>
                    </div>
                </Col>
          
             )}
               </Row>
        </Container>
    );
}
